import { Theme } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => ({
  clearAllSelected: {
    fontSize: "11px",
    padding: 0,
    textTransform: "none",
    justifyContent: "left",
    color: theme.palette.primary.main,
    "&.Mui-focusVisible": {
      border: "2px solid #000000",
      fontWeight: 700,
      "& .MuiTouchRipple-child": {
        backgroundColor: "transparent",
      },
    },
  },
  statusElement: {
    height: 0,
    width: 0,
    opacity: 0,
  },
}));
